import type {SlotGameStore, BaseComponentConfig} from "@gamzix/slot_core";

import {CONST} from "../../../src/const";

class JackpotComponent extends Game.src.component.BaseComponent {
    private jackpotPanel;

    constructor(config: BaseComponentConfig) {
        super(config);

        const store = <SlotGameStore>game.store;

        this.text_checkers = {
            ...super.getTextCheckers(),

            GET_PLATINUM_VALUE: () => store.toFormatMoney(store.gameData.bet * CONST.JACKPOT.PLATINUM_MULTIPLIER),
            GET_GOLD_VALUE: () => store.toFormatMoney(store.gameData.bet * CONST.JACKPOT.GOLD_MULTIPLIER),
            GET_SILVER_VALUE: () => store.toFormatMoney(store.gameData.bet * CONST.JACKPOT.SILVER_MULTIPLIER),
            GET_BRONZE_VALUE: () => store.toFormatMoney(store.gameData.bet * CONST.JACKPOT.BRONZE_MULTIPLIER)
        };
    }

    onGameReady() {
        super.onGameReady();

        this.jackpotPanel = game.tree.findByName('jackpot_panel.wrapper_container');

        this.updateLabelScale();
    }

    onResize(width: number, height: number) {
        super.onResize(width, height);

        this.updateLabelScale();
    }

    onChangeOrientation() {
        super.onChangeOrientation();

        this.updateLabelScale();
    }

    updateLabelScale() {
        if(!this.view) return;

        const platinumLabel = game.tree.findByName('jackpot_panel.wrapper_container.platinum_panel.label', game.tree.findAll(this.view));
        const goldLabel = game.tree.findByName('jackpot_panel.wrapper_container.gold_panel.label', game.tree.findAll(this.view));
        const silverLabel = game.tree.findByName('jackpot_panel.wrapper_container.silver_panel.label', game.tree.findAll(this.view));
        const bronzeLabel = game.tree.findByName('jackpot_panel.wrapper_container.bronze_panel.label', game.tree.findAll(this.view));

        goldLabel.scale.set(platinumLabel.text.scale.x);
        silverLabel.scale.set(platinumLabel.text.scale.x);
        bronzeLabel.scale.set(platinumLabel.text.scale.x);
    }

    setParentGroup(obj, parentGroupName, zOrder) {
        obj.parentGroup = game.render.layerGroups[parentGroupName];
        obj.zOrder = zOrder;

        this.onChangeOrientation();
    }

    get store(): SlotGameStore {
        return <SlotGameStore>game.store;
    }

    getFSMHandlers(): any {
        return {
            CHECK: {
                checkStartBonusGame: {
                    on: () => {
                        this.setParentGroup(this.jackpotPanel, "OVERLAY", 50);
                    },
                },
                checkFinishBonusGame: {
                    on: () => {
                        this.setParentGroup(this.jackpotPanel, "OVERLAY", 50);
                    },
                }
            },
            GAMBLE: {
                open: {
                    on: () => {
                        this.setParentGroup(this.jackpotPanel, "OVERLAY", 50);
                    },
                },
            },
            IDLE: {
                enter: {
                    on: () => {
                        this.setParentGroup(this.jackpotPanel, "GAME", 10);
                    },
                }
            },
        }
    }
}

//@ts-ignore
Game.src.component.JackpotComponent = JackpotComponent;